import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GenericModalComponent } from './generic-modal.component';

@NgModule({
  declarations: [GenericModalComponent],
  exports: [GenericModalComponent],
  imports: [TranslateModule]
})
export class GenericModalModule {}
